/**
 * Tema reutilizável alinhado ao borracharia_major (listagens modernas escuras).
 */
import styled from 'styled-components';

export const FormWrapper = styled.div`
  .MuiFormControl-root {
    .MuiInputLabel-root {
      color: #b0b0b0 !important;

      &.Mui-focused {
        color: #00d4ff !important;
      }
    }

    .MuiOutlinedInput-root {
      background: rgba(255, 255, 255, 0.05);
      border-radius: 8px;
      color: #ffffff !important;
      transition: all 0.3s ease;
      height: 48px !important;
      min-height: 48px !important;

      @media (min-width: 768px) {
        border-radius: 9px;
        height: 52px !important;
        min-height: 52px !important;
      }

      @media (min-width: 992px) {
        border-radius: 10px;
        height: 56px !important;
        min-height: 56px !important;
      }

      fieldset {
        border-color: rgba(255, 255, 255, 0.1);
        border-width: 2px;
      }

      &:hover fieldset {
        border-color: rgba(0, 212, 255, 0.3);
      }

      &.Mui-focused {
        background: rgba(255, 255, 255, 0.08);

        fieldset {
          border-color: #00d4ff;
          border-width: 2px;
        }
      }

      .MuiInputBase-input {
        color: #ffffff !important;
        height: 48px !important;
        padding: 12px 14px !important;
        font-size: 14px !important;

        @media (min-width: 768px) {
          height: 52px !important;
          padding: 14px 14px !important;
          font-size: 15px !important;
        }

        @media (min-width: 992px) {
          height: 56px !important;
          padding: 16.5px 14px !important;
          font-size: 16px !important;
        }

        &::placeholder {
          color: #888;
          opacity: 1;
        }
      }

      /* Textarea (multiline): não forçar altura de input de uma linha */
      &.MuiOutlinedInput-multiline {
        height: auto !important;
        min-height: 0 !important;
        align-items: stretch;
        padding: 0 !important;

        textarea.MuiOutlinedInput-input,
        .MuiInputBase-inputMultiline {
          height: auto !important;
          min-height: 120px !important;
          padding: 12px 14px !important;
          line-height: 1.55 !important;
          resize: vertical;
          box-sizing: border-box !important;
          overflow: auto !important;
          font-size: 14px !important;

          @media (min-width: 768px) {
            min-height: 128px !important;
            padding: 14px 14px !important;
            font-size: 15px !important;
          }

          @media (min-width: 992px) {
            min-height: 136px !important;
            padding: 14px 16px !important;
            font-size: 16px !important;
          }

          &::placeholder {
            color: rgba(255, 255, 255, 0.38);
            opacity: 1;
          }
        }
      }

      /*
       * Select: o mesmo .MuiInputBase-input força height+padding de input de texto;
       * no Select isso desloca o valor/placeholder verticalmente. O root já tem altura fixa.
       */
      .MuiSelect-select.MuiOutlinedInput-input {
        display: flex !important;
        align-items: center !important;
        box-sizing: border-box !important;
        height: 100% !important;
        min-height: 0 !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        padding-left: 14px !important;
        padding-right: 36px !important;
        line-height: 1.3 !important;
        font-size: 14px !important;

        @media (min-width: 768px) {
          font-size: 15px !important;
        }

        @media (min-width: 992px) {
          font-size: 16px !important;
          padding-right: 38px !important;
        }
      }

      /* Ícones dentro do campo (calendar, setas, etc.) */
      .MuiInputAdornment-root {
        color: #ffffff !important;

        .MuiInputAdornment-positionStart,
        .MuiInputAdornment-positionEnd {
          color: #ffffff !important;
        }

        .MuiTypography-root {
          color: #ffffff !important;
        }

        .MuiIconButton-root {
          color: #ffffff !important;

          svg {
            color: #ffffff !important;
            fill: currentColor !important;
          }
        }

        svg {
          color: #ffffff !important;
          fill: currentColor !important;
        }
      }

      .MuiSvgIcon-root {
        color: #ffffff !important;
        fill: currentColor !important;
      }

      .MuiIconButton-root {
        color: #ffffff !important;

        svg {
          color: #ffffff !important;
          fill: currentColor !important;
        }
      }

      .MuiSelect-icon {
        color: #ffffff !important;
        fill: currentColor !important;
      }
    }

    .MuiFormHelperText-root {
      color: #b0b0b0;
    }

    .MuiSelect-root {
      color: #ffffff !important;
    }

    .MuiSelect-icon {
      color: #ffffff !important;
      fill: currentColor !important;
    }
  }

  /* DatePicker / adornos fora do nesting direto */
  .MuiInputAdornment-root {
    color: #ffffff !important;

    .MuiTypography-root {
      color: #ffffff !important;
    }

    .MuiIconButton-root {
      color: #ffffff !important;

      svg {
        color: #ffffff !important;
        fill: currentColor !important;
      }
    }

    svg {
      color: #ffffff !important;
      fill: currentColor !important;
    }
  }

  /* Autocomplete (par de moedas etc.) */
  .MuiAutocomplete-root {
    .MuiOutlinedInput-root {
      .MuiAutocomplete-endAdornment {
        .MuiIconButton-root {
          color: #ffffff !important;

          svg {
            color: #ffffff !important;
            fill: currentColor !important;
          }
        }

        .MuiSvgIcon-root {
          color: #ffffff !important;
          fill: currentColor !important;
        }
      }
    }

    .MuiAutocomplete-popupIndicator,
    .MuiAutocomplete-clearIndicator {
      color: #ffffff !important;

      svg {
        color: #ffffff !important;
        fill: currentColor !important;
      }
    }
  }

  .MuiOutlinedInput-root .MuiSelect-icon {
    color: #ffffff !important;
    fill: currentColor !important;
  }

  .MuiMenuItem-root {
    background: #1a1a2e;
    color: #e0e0e0;

    &:hover {
      background: rgba(0, 212, 255, 0.1);
    }

    &.Mui-selected {
      background: rgba(0, 212, 255, 0.2);
      color: #00d4ff;
    }
  }
`;

export const OrangeAccentCard = styled.div`
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(242, 146, 5, 0.2);
  border: 1px solid rgba(242, 146, 5, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  position: relative;

  @media (min-width: 576px) {
    border-radius: 18px;
    padding: 24px;
  }

  @media (min-width: 768px) {
    border-radius: 20px;
    padding: 28px;
  }

  @media (min-width: 992px) {
    padding: 32px;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 15px 50px rgba(0, 0, 0, 0.6), 0 0 0 1px rgba(242, 146, 5, 0.3);
  }
`;
